﻿import { debounce } from '../functions.js';

document.addEventListener('DOMContentLoaded', () => {
    const $body = document.body;
    let prevScroll = 0;
    const $navbar = document.getElementById('navbar');

    document.addEventListener('scroll', debounce(() => {
        if ($navbar) {
            if (window.scrollY === 0) {
                $body.classList.remove('is-scrolled');
            }
            else {
                $body.classList.add('is-scrolled');
            }

            if (prevScroll > window.scrollY) {
                $body.classList.remove('is-scroll-down');
                $body.classList.add('is-scroll-up');
            } else if (prevScroll < window.scrollY) {
                $body.classList.add('is-scroll-down');
                $body.classList.remove('is-scroll-up');
            }
            prevScroll = window.scrollY;
        }
    }, 50));
});